import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';

import { MUIModal } from 'Components/Base';
import Diagnose from 'Components/Diagnose';
import { useOffset } from 'Context/LayoutContext/OffsetProvider';
import getConfig from 'Util/Config';

const useModalStyle = makeStyles({
  paper: ({ topOffset }) => ({
    height: '100vh',
    width: '100vw',
    position: 'fixed',
    bottom: 0,
    margin: '0 24px',
    paddingTop: topOffset ?? 0,
    maxHeight: 'unset',
    maxWidth: 'unset',
    '& > #close-icon': {
      top: topOffset || 20,
    },
    '@media (min-width:768px)': {
      maxWidth: '1024px',
      maxHeight: 'calc(100% - 64px)',
      height: 'auto',
      width: '100%',
      borderRadius: '16px',
      position: 'relative',
      bottom: 'inherit',
    },
  }),
});

const HealthCheckModal = ({ onOpenModal, onCloseModal, toggleComponent }) => {
  const { timeResponse } = getConfig();
  const { topOffset } = useOffset();
  const modalClasses = useModalStyle({ topOffset });

  return (
    <MUIModal
      disableBackdropClick
      disableEscapeKeyDown
      classes={modalClasses}
      onOpenModal={onOpenModal}
      onCloseModal={onCloseModal}
      toggleComponent={React.isValidElement(toggleComponent) ? toggleComponent : undefined}
    >
      <Diagnose timeResponse={timeResponse} />
    </MUIModal>
  );
};

HealthCheckModal.propTypes = {
  onOpenModal: PropTypes.func,
  onCloseModal: PropTypes.func,
  toggleComponent: PropTypes.func,
};

export default HealthCheckModal;
